import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

type OutOfStockProp = {
    $isOutOfStock: boolean;
};

export const ProductPreOrderStockStatusWrapper = styled.div`
    align-items: center;
    display: grid;
    grid-template-columns: 1.875rem 1fr;
    max-width: 29.625rem;
    width: 100%;
    padding: ${getPurpurSpacing('250')};
    background-color: ${getPurpurColor('gray50')};
    margin-top: ${getPurpurSpacing('400')};
    margin-bottom: ${getPurpurSpacing('400')};
    border: 0.063rem solid rgba(0, 0, 0, 0.05);
`;

export const StockSubtext = styled.div`
    font-size: ${getPurpurTypography('scale50')};
    color: rgba(0, 0, 0, 0.7);
    grid-column: 2;
    grid-row: 2;
`;

export const CurrentStockStatusContainer = styled.div<OutOfStockProp>`
    align-items: center;
    display: grid;
    grid-template-columns: 1.875rem 1fr;
    color: ${({ $isOutOfStock }) => ($isOutOfStock ? getPurpurColor('red600') : 'inherit')};
    padding: ${getPurpurSpacing('400')} 0;
`;
